import { Trans } from "react-i18next"

import util from "utils/utils"

const ProjectAssignedManager = ({ events, ownerIdea = { name: "Undefined" } }) => {
  return (
    <Trans i18nKey="notifications.projectAssignedManager">
      <b>{{ name: util.getEventNames(events) }}</b>
      has assigned
      <b>{{ assignee: util.getEventNames(events, "ownerAssignee") }}</b>
      to help project-manage the idea
      <b>{{ idea: ownerIdea.name }}</b>.
    </Trans>
  )
}

export default ProjectAssignedManager
